import { useState, useCallback } from 'react'
import { MapRefreshContext } from './use-map-refresh'

export const MapRefreshProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1)
  }, [])

  return (
    <MapRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </MapRefreshContext.Provider>
  )
}
